import { Skeleton, SkeletonCircle, Stack } from "@chakra-ui/react";

function SidebarGroupSkeleton() {
  return (
    <Stack spacing={"30px"} display={"none"}>
      {["", "", "", "", ""].map((data) => (
        <Stack direction={"row"} alignItems="center">
          {" "}
          <SkeletonCircle size="5" />
          <Stack>
            <Skeleton height="5px" width="100px" />
            <Skeleton height="5px" width="50px" />
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
}

export default SidebarGroupSkeleton;
